import React, { useEffect, useReducer, useState } from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import SetupDocs, { getSetupDoc } from '../../documentation/SetupDocs';
import Grid from '@material-ui/core/Grid';
import { StyledRadio } from '../../../../../utils/designComponents/StyledRadio';
import TextButtonWithDocumentation from '../../documentation/TextButtonDocumentation';
import WorkOrdersDoc from '../../documentation/WorkOrderDocumentation';
import Input from '@material-ui/core/Input';
import { FormLabel } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import InfoIconComponent from './InfoIcon';
import FTFCSetup from './FTFCSetup';
import BreakCandleTypeSetup from './BreakCandleTypeSetup';
import Button from '@material-ui/core/Button';
import CandlePatternSetup from './CandlePatternSetup';

const timeUnits = ['MINUTES', 'DAYS', 'WEEKS', 'MONTHS'];

function setFlagPattern(top, dispatchSetUpDetails, terminateOnFail) {
  if (top.goLong && !top.goShort) {
    dispatchSetUpDetails({
      pattern: [
        [
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ],
        /*   [
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'OUTSIDE_CANDLE_UP',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ], */
      ],
    });
  } else if (!top.goLong && top.goShort) {
    dispatchSetUpDetails({
      pattern: [
        [
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ],
        /*  [
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'OUTSIDE_CANDLE_DOWN',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ], */
      ],
    });
  } else {
    dispatchSetUpDetails({
      pattern: [
        [
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ],
        /*  [
          {
            candleSequence: 'BREAK_HIGH',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_HIGH',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'OUTSIDE_CANDLE_UP',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ], */
        [
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ],
        /* [
          {
            candleSequence: 'BREAK_LOW',
            terminateOnFail: terminateOnFail,
            restartOnFail: false,
          },
          {
            candleSequence: 'FAIL_TO_BREAK_LOW',
            terminateOnFail: false,
            restartOnFail: false,
          },
          {
            candleSequence: 'OUTSIDE_CANDLE_DOWN',
            terminateOnFail: false,
            restartOnFail: false,
          },
        ], */
      ],
    });
  }
}

const Setup = (props) => {
  //const classes = useStyles();

  let top = props.top;
  let dispatchTop = props.dispatchTop;
  let setUpOptions = props.setUpOptions;
  let setupFields = props.setupFields;
  let dispatchSetUpDetails = props.dispatchSetUpDetails;

  //let [candleClosePctText, setCandleClosePctText] = useState("0");
  // let [gapPctText, setGapPctText] = useState("0");
  //let [breakByTxt, setBreakByTxt] = useState("0");

  //      useEffect(() => {
  //            setBreakByTxt(setupFields.breakBy + "");
  //    }, [setupFields.breakBy]);

  /*  useEffect(() => {
              setCandleClosePctText(setupFields.candleClosePct * 100 + "");
              setGapPctText(
                  setupFields.permittedGapPct === -2147483648
                      ? ""
                      : setupFields.permittedGapPct * 100 + ""
              );
          }, [setupFields.candleClosePct, setupFields.permittedGapPct]);*/

  useEffect(() => {
    if (setupFields.timeUnit === 'MINUTES') {
      if (
        parseInt(setupFields.candlesBack) !== 0 ||
        parseInt(setupFields.candlesBack) !== 1
      ) {
        dispatchSetUpDetails({ candlesBack: 1 });
      }
    }
  }, [setupFields.timeUnit]);
  useEffect(() => {
    if (top.setup === 'FLAG') {
      let isTerminateOnFail = false;
      if (setupFields.pattern.length > 0) {
        if (setupFields.pattern[0].length > 0) {
          if (setupFields.pattern[0][0].terminateOnFail) {
            isTerminateOnFail = true;
          }
        }
      }
      setFlagPattern(top, dispatchSetUpDetails, isTerminateOnFail);
    }
  }, [top.goLong, top.goShort]);
  /*useEffect(() => {
            if (top.setup === "FLAG") {
                // if (setupFields.pattern !== undefined && setupFields.pattern.length > 0) {
                //     return;
                // }
                dispatchSetUpDetails({
                    pattern: [
                        {
                            candleSequence: "BREAK_CANDLE",
                            terminateOnFail: false,
                            restartOnFail: false,
                        },
                        {
                            candleSequence: "FAIL_TO_BREAK_CANDLE",
                            terminateOnFail: false,
                            restartOnFail: false,
                        },
                        {
                            candleSequence: "BREAK_CANDLE",
                            terminateOnFail: false,
                            restartOnFail: false,
                        },
                    ],
                });
            }
        }, [top.setup]);*/

  return (
    <Grid container>
      <Grid item container>
        <Grid item xs={12}>
          <Typography style={{ fontSize: 12 }}>
            <u>SETUPS</u>
          </Typography>
        </Grid>
        {Object.entries(setUpOptions).map(([opt, { label, key }]) => {
          return (
            <Grid item xs={2} key={label}>
              <Button
                key={label}
                style={{
                  fontSize: 10,
                  backgroundColor: top.setup === key ? 'lightgray' : 'white',
                  color: top.setup === key ? 'blue' : 'black',
                  height: '100%',
                  width: '100%',
                }}
                value={key}
                onClick={(ev) => {
                  dispatchTop({ setup: key });
                  if (key === 'CANDLE_TRIGGER') {
                    dispatchSetUpDetails({ timeUnit: 'DAYS' });
                  } else if (key === 'BREAK_EMA' || key === 'BOUNCE_EMA') {
                    dispatchSetUpDetails({ timeUnit: 'MINUTES' });
                  }
                  if (key === 'CANDLE_PATTERN') {
                    dispatchSetUpDetails({ pattern: [] });
                  }
                  if (key === 'FLAG') {
                    // if (setupFields.pattern !== undefined && setupFields.pattern.length > 0) {
                    //     return;
                    // }
                    setFlagPattern(top, dispatchSetUpDetails, false);
                  }
                }}
              >
                <InfoIconComponent docs={getSetupDoc(label)} /> {label}
              </Button>
            </Grid>
          );
        })}
      </Grid>
      {top.setup === 'BREAK' || top.setup === 'BOUNCE' ? (
        <BounceBreakSetup
          dispatchSetUpDetails={dispatchSetUpDetails}
          setupFields={setupFields}
          top={top}
        />
      ) : top.setup === 'BOUNCE_EMA' || top.setup === 'BREAK_EMA' ? (
        <EmaSetups
          dispatchSetUpDetails={dispatchSetUpDetails}
          setupFields={setupFields}
        />
      ) : top.setup === 'CANDLE_TRIGGER' ? (
        <CandleTriggerSetup
          setupFields={setupFields}
          dispatchSetUpDetails={dispatchSetUpDetails}
        />
      ) : top.setup === 'CONVICTION_CANDLE' ? (
        <ConvictionCandleSetup
          setupFields={setupFields}
          dispatchSetUpDetails={dispatchSetUpDetails}
        />
      ) : top.setup === 'FLAG' ? (
        <FlagSetup
          setupFields={setupFields}
          dispatchSetUpDetails={dispatchSetUpDetails}
          top={top}
        />
      ) : top.setup === 'FTFC' ? (
        <FTFCSetup
          //top={top}
          dispatchSetUpDetails={dispatchSetUpDetails}
          setupDetailTimeFrames={setupFields.timeFrames}
        />
      ) : top.setup === 'BREAK_CANDLE_TYPE' ? (
        <BreakCandleTypeSetup
          top={top}
          dispatchTop={dispatchTop}
          dispatchSetUpDetails={dispatchSetUpDetails}
          setupFields={setupFields}
        />
      ) : top.setup === 'CANDLE_PATTERN' ? (
        <CandlePatternSetup
          setupFields={setupFields}
          dispatchSetupDetails={dispatchSetUpDetails}
        />
      ) : top.setup === 'ORB' ? (
        <OrbSetup
          setupFields={setupFields}
          dispatchSetUpDetails={dispatchSetUpDetails}
        />
      ) : (
        <></>
      )}
    </Grid>
  );
};
function OrbSetup({ setupFields, dispatchSetUpDetails }) {
  const [breakByTxt, setBreakByTxt] = useState('0');
  useEffect(() => {
    setBreakByTxt(setupFields.breakBy + '');
  }, [setupFields.breakBy]);

  return (
    <Grid container>
      <Grid item xs={2}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}>Candle Duration</Typography>
          }
          value={setupFields.candleDuration}
          onChange={(ev) =>
            dispatchSetUpDetails({
              candleDuration: parseInt(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={<Typography style={{ fontSize: 10 }}>break by</Typography>}
          value={breakByTxt}
          onChange={(ev) => setBreakByTxt(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({
              breakBy: parseFloat(ev.target.value),
            })
          }
        />
      </Grid>
    </Grid>
  );
}

const EmaSetups = ({ setupFields, dispatchSetUpDetails }) => {
  return (
    <div>
      <FormControl
        component="fieldset"
        //       variant="outlined"
        //     className={classes.formControl}
      >
        <FormGroup row>
          <Grid item xs={1}></Grid>
          <Grid xs={3}>
            <FormControlLabel
              control={
                <TextField
                  size={'small'}
                  id="outlined-basic"
                  label={
                    <Typography style={{ fontSize: 10 }}>
                      Candle Duration
                    </Typography>
                  }
                  //             variant="outlined"
                  value={setupFields.candleDuration}
                  onChange={(ev) => {
                    dispatchSetUpDetails({
                      candleDuration: ev.target.value,
                    });
                  }}
                />
              }
            />
          </Grid>
          <Grid xs={3}>
            <FormControlLabel
              control={
                <TextField
                  size={'small'}
                  id="outlined-basic"
                  label={
                    <Typography style={{ fontSize: 10 }}>periods</Typography>
                  }
                  //                     variant="outlined"
                  value={setupFields.periodLengths}
                  onChange={(ev) =>
                    dispatchSetUpDetails({
                      periodLengths: ev.target.value,
                    })
                  }
                />
              }
            />
          </Grid>
          <Grid xs={3}>
            <Select
              labelId="simple-select-outlined-label"
              id="simple-select-outlined-label"
              value={setupFields.timeUnit}
              checked={setupFields.timeUnit}
              onChange={(ev) =>
                dispatchSetUpDetails({
                  setupFields: ev.target.value,
                })
              }
              label="Time Unit"
            >
              <MenuItem value="MINUTES">
                {<Typography style={{ fontSize: 12 }}>Minutes</Typography>}
              </MenuItem>
            </Select>
          </Grid>
        </FormGroup>
      </FormControl>
    </div>
  );
};

const BounceBreakSetup = ({ setupFields, dispatchSetUpDetails, top }) => {
  return (
    <Grid item xs={2}>
      <TextField
        size={'small'}
        id="outlined-basic"
        label={
          <Typography style={{ fontSize: 10 }}>
            Price to {top.setup === 'BREAK' ? 'Break' : 'Bounce'}
          </Typography>
        }
        //   variant="outlined"
        style={{ fontSize: 10 }}
        value={setupFields.priceToBreak}
        onChange={(ev) =>
          dispatchSetUpDetails({ priceToBreak: ev.target.value })
        }
        //    required
      />
    </Grid>
  );
};

const CandleTriggerSetup = ({ setupFields, dispatchSetUpDetails }) => {
  const [breakByTxt, setBreakByTxt] = useState('0');
  const [otherSelected, setOtherSelected] = useState(false);

  useEffect(() => {
    if (setupFields.candlesBack > 1 && !otherSelected) {
      setOtherSelected(true);
    }
  }, [setupFields.candlesBack]);

  useEffect(() => {
    if (setupFields.bounceOnGapFill && setupFields.timeUnit === 'MINUTES') {
      dispatchSetUpDetails({ bounceOnGapFill: false });
    }
  }, [setupFields.timeUnit]);
  useEffect(() => {
    if (setupFields.candlesBack > 1 && setupFields.timeUnit === 'MINUTES') {
      dispatchSetUpDetails({ candlesBack: 1 });
    }
  }, [setupFields.candlesBack, setupFields.timeUnit]);

  useEffect(() => {
    setBreakByTxt(setupFields.breakBy + '');
  }, [setupFields.breakBy]);

  return (
    <Grid item container>
      <Grid item xs={2}>
        <TextField
          select
          value={setupFields.timeUnit}
          variant="outlined"
          size="small"
          style={{ backgroundColor: 'white', width: '100%' }}
          onChange={(ev) => dispatchSetUpDetails({ timeUnit: ev.target.value })}
          label={<Typography style={{ fontSize: 8 }}>timeUnit</Typography>}
        >
          {timeUnits.map((timeUnit) => (
            <MenuItem key={timeUnit} value={timeUnit}>
              <Typography style={{ fontSize: 9 }}>{timeUnit}</Typography>
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {/* <Grid item xs={2}>
                <FormLabel color="primary">
                    <Typography style={{fontSize: 10}}>
                        <b>Candles Back:</b>
                    </Typography>
                </FormLabel>
            </Grid>*/}
      <RadioGroup
        style={{ fontSize: 12 }}
        row
        onChange={(ev) => {
          let value = ev.target.value;
          switch (value) {
            case 'current':
            case 'today':
              dispatchSetUpDetails({
                candlesBack: 0,
              });
              if (otherSelected) {
                setOtherSelected(false);
              }
              break;
            case 'last':
            case 'yesterday':
              dispatchSetUpDetails({
                candlesBack: 1,
              });
              if (otherSelected) {
                setOtherSelected(false);
              }
              break;
            default:
              dispatchSetUpDetails({
                candlesBack: 2,
              });
              setOtherSelected(true);
              break;
          }
        }}
      >
        <FormControlLabel
          checked={setupFields.candlesBack === 0}
          value={setupFields.timeUnit === 'DAYS' ? 'today' : 'current'}
          control={<StyledRadio />}
          label={
            <Typography style={{ fontSize: 8 }}>
              {setupFields.timeUnit === 'DAYS' ? 'today' : 'current'}
            </Typography>
          }
        />
        <FormControlLabel
          checked={setupFields.candlesBack === 1}
          value={setupFields.timeUnit === 'DAYS' ? 'yesterday' : 'last'}
          control={<StyledRadio />}
          label={
            <Typography style={{ fontSize: 8 }}>
              {setupFields.timeUnit === 'DAYS' ? 'yesterday' : 'last'}
            </Typography>
          }
        />
        <FormControlLabel
          checked={setupFields.candlesBack > 1}
          value={'other'}
          control={<StyledRadio />}
          label={<Typography style={{ fontSize: 8 }}>other</Typography>}
        />
      </RadioGroup>
      {otherSelected ? (
        <Grid item xs={1}>
          <Input
            id="outlined-basic"
            //label={<Typography style={{fontSize: 12}}>Candles Back</Typography>}
            //   variant="outlined"
            value={setupFields.candlesBack}
            readOnly={setupFields.timeUnit === 'MINUTES'}
            onChange={(ev) =>
              dispatchSetUpDetails({
                candlesBack: parseInt(ev.target.value),
              })
            }
          />
        </Grid>
      ) : null}
      <Grid item xs={2}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}>Candle Duration</Typography>
          }
          value={setupFields.candleDuration}
          onChange={(ev) =>
            dispatchSetUpDetails({
              candleDuration: parseInt(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={1}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={<Typography style={{ fontSize: 10 }}>break by</Typography>}
          value={breakByTxt}
          onChange={(ev) => setBreakByTxt(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({
              breakBy: parseFloat(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={12} container>
        <Grid item xs={2}>
          <FormControlLabel
            value="top"
            control={
              <Checkbox
                color="primary"
                checked={setupFields.checkValidation}
                onChange={(ev) =>
                  dispatchSetUpDetails({
                    checkValidation: ev.target.checked,
                  })
                }
              />
            }
            label={
              <Typography style={{ fontSize: 10 }}>validate candle</Typography>
            }
            labelPlacement="start"
            size="small"
          />
        </Grid>
        {setupFields.timeUnit !== 'MINUTES' && setupFields.checkValidation ? (
          <Grid item xs={2}>
            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  color="primary"
                  checked={setupFields.bounceOnGapFill}
                  onChange={(ev) =>
                    dispatchSetUpDetails({
                      bounceOnGapFill: ev.target.checked,
                    })
                  }
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  bounce on gap fill
                </Typography>
              }
              labelPlacement="start"
              size="small"
            />
          </Grid>
        ) : null}
        {setupFields.bounceOnGapFill ? (
          <Grid item xs={2}>
            <TextField
              select
              value={setupFields.gapType}
              variant="outlined"
              size="small"
              style={{ backgroundColor: 'white', width: '100%' }}
              onChange={(ev) =>
                dispatchSetUpDetails({ gapType: ev.target.value })
              }
              label={<Typography style={{ fontSize: 8 }}>Gap Type</Typography>}
            >
              {[
                { type: 'highLow', label: 'high/low' },
                { type: 'openClose', label: 'open/close' },
              ].map(({ type, label }) => (
                <MenuItem key={type} value={type}>
                  <Typography style={{ fontSize: 9 }}>{label}</Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

const ConvictionCandleSetup = ({ dispatchSetUpDetails, setupFields }) => {
  let [candleClosePctText, setCandleClosePctText] = useState('0');
  let [gapPctText, setGapPctText] = useState('0');

  useEffect(() => {
    setCandleClosePctText(setupFields.candleClosePct * 100 + '');
    setGapPctText(
      setupFields.permittedGapPct === -2147483648
        ? ''
        : setupFields.permittedGapPct * 100 + ''
    );
  }, [setupFields.candleClosePct, setupFields.permittedGapPct]);
  return (
    <Grid container>
      <FormControl
        component="fieldset"
        //    className={classes.formControl}
      >
        <FormGroup row>
          <Grid item xs={1}></Grid>
          <Grid item xs={1}>
            <FormControlLabel
              control={
                <TextField
                  id="outlined-basic"
                  label={
                    <Typography style={{ fontSize: 10 }}>
                      Candle Duration
                    </Typography>
                  }
                  //                 variant="outlined"
                  value={setupFields.candleDuration}
                  onChange={(ev) =>
                    dispatchSetUpDetails({
                      candleDuration: ev.target.value,
                    })
                  }
                  //              required
                />
              }
            />
          </Grid>
          <Grid item xs={1}>
            <FormControlLabel
              control={
                <TextField
                  id="outlined-basic"
                  label={
                    <Typography style={{ fontSize: 10 }}>
                      min 1st candleHeight
                    </Typography>
                  }
                  //                variant="outlined"
                  value={setupFields.minimumFirstCandleHeight}
                  onChange={(ev) =>
                    dispatchSetUpDetails({
                      minimumFirstCandleHeight: ev.target.value,
                    })
                  }
                  //             required
                />
              }
            />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={setupFields.rightColorCandle}
                  onChange={(ev) =>
                    dispatchSetUpDetails({
                      rightColorCandle: ev.target.checked,
                    })
                  }
                  name="rightColorCandle"
                />
              }
              label={
                <Typography style={{ fontSize: 10 }}>
                  right color candle
                </Typography>
              }
              labelPlacement={'top'}
            />
          </Grid>
          <Grid item xs={2}>
            <FormControlLabel
              control={
                <TextField
                  id="outlined-basic"
                  label={
                    <Typography style={{ fontSize: 10 }}>
                      Candle close %
                    </Typography>
                  }
                  //variant="outlined"
                  value={candleClosePctText}
                  onChange={(ev) => setCandleClosePctText(ev.target.value)}
                  onBlur={(ev) =>
                    dispatchSetUpDetails({
                      candleClosePct:
                        ev.target.value !== '' ? ev.target.value / 100 : 0,
                    })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography style={{ fontSize: 13 }}>%</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              }
            />
          </Grid>
          <Grid item xs={4}>
            <Grid item container>
              <Grid item xs={8}>
                <FormControlLabel
                  value="top"
                  control={
                    <Checkbox
                      color="primary"
                      checked={setupFields.permittedGapPct !== -2147483648}
                      onChange={(ev) =>
                        dispatchSetUpDetails({
                          permittedGapPct: ev.target.checked ? 0 : -2147483648,
                        })
                      }
                    />
                  }
                  label={
                    <Typography style={{ fontSize: 10 }}>
                      permitted gap %
                    </Typography>
                  }
                  labelPlacement="top"
                />
              </Grid>
              {setupFields.permittedGapPct !== -2147483648 ? (
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <TextField
                        id="outlined-basic"
                        label={
                          <Typography style={{ fontSize: 10 }}>
                            {' '}
                            gap %
                          </Typography>
                        }
                        //       helperText="Input a decimal between 0 and 1"
                        //             variant="outlined"
                        value={gapPctText}
                        size={'small'}
                        onChange={(ev) => setGapPctText(ev.target.value)}
                        onBlur={(ev) =>
                          dispatchSetUpDetails({
                            permittedGapPct:
                              ev.target.value === ''
                                ? -2147483648
                                : ev.target.value / 100,
                          })
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Typography style={{ fontSize: 13 }}>
                                %
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                      />
                    }
                  />
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </FormGroup>
      </FormControl>
    </Grid>
  );
};

const FlagSetup = ({ dispatchSetUpDetails, setupFields, top }) => {
  let [breakByTxt, setBreakByTxt] = useState('0');

  useEffect(() => {
    setBreakByTxt(setupFields.breakBy + '');
  }, [setupFields.breakBy]);

  return (
    <Grid container>
      <Grid item xs={2}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}>Candle Duration</Typography>
          }
          value={setupFields.candleDuration}
          onChange={(ev) =>
            dispatchSetUpDetails({
              candleDuration: parseInt(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          variant="outlined"
          id="outlined-basic"
          size={'small'}
          label={<Typography style={{ fontSize: 10 }}>break by</Typography>}
          value={breakByTxt}
          onChange={(ev) => setBreakByTxt(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({
              breakBy: parseFloat(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          value="top"
          control={
            <Checkbox
              color="primary"
              checked={
                setupFields.pattern.length > 0 &&
                setupFields.pattern[0].length > 0
                  ? setupFields.pattern[0][0]['terminateOnFail']
                  : false
              }
              onChange={(ev) =>
                setFlagPattern(top, dispatchSetUpDetails, ev.target.checked)
              }
            />
          }
          label={
            <Typography style={{ fontSize: 10 }}>
              fail on first candle
            </Typography>
          }
          labelPlacement="top"
          size="small"
        />
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          value="top"
          control={
            <Checkbox
              color="primary"
              checked={setupFields.waitUntilCurrentCandleCloses}
              onChange={(ev) =>
                dispatchSetUpDetails({
                  waitUntilCurrentCandleCloses: ev.target.checked,
                })
              }
            />
          }
          label={
            <Typography style={{ fontSize: 10 }}>
              waitUntilCurrentCandleCloses
            </Typography>
          }
          labelPlacement="top"
          size="small"
        />
      </Grid>
    </Grid>
  );
};
export default Setup;
